export function diffRoster(teams, allowedGameIds) {
  const norm = (s) => String(s ?? "").trim();
  const allowed = new Set(allowedGameIds.map(norm));
  const seen = new Set();
  const notInRoster = [];
  teams.forEach((t) =>
    (t.players || []).forEach((p) => {
      const id = norm(p.id);
      if (!id || seen.has(id)) return;
      seen.add(id);
      if (!allowed.has(id)) notInRoster.push({ id, firstSeenTeam: t.rank });
    })
  );
  return {
    notInRoster,
    count: notInRoster.length,
    sample: notInRoster.slice(0, 10),
  };
}
